<template>
  <div class="d-contents">
    <NuxtPage />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { createSinaContext } from '~/composables/sinaContext'

export default defineComponent({
  name: 'SinaPages',
  components: {},
  props: {},
  setup() {
    createSinaContext()
    return {}
  },

  data() {
    return {}
  },
  computed: {},
  methods: {},
})
</script>

<style scoped lang="scss"></style>
